import { api } from './../../api.js';
import { config } from './../../config.js';
import { usePerfil } from '@/composables/front/perfil/usePerfil';

const state = {
    token : null,
    is_logged : false,
    role : 0,
    menu_active : false,
    search_active : false,
    user_content_active : false,
    page_loading : false,
    permissions : [],
    name: '',
    user : null,
    lista_id: null,
    teatro_id: null,
    permisos: null,
    gd: null,
    listas : [],
    lista_activa: null,
    event_can_view: null,
    datafono: null,
    puede_datafono: false,
    events_can_view: []
}

const getters = {
    getEventCanView : state => {
        return state.event_can_view;
    },
    getEventsCanView : state => {
        return state.events_can_view;
    },
    getUserToken : state => {
        return state.token;
    },
    isLogged : state => {
        return state.is_logged;
    },
    getRole : state => {
        return state.role;
    },
    getMenuActive : state => {
        return state.menu_active;
    },
    getSearchActive : state => {
        return state.search_active;
    },
    getUserContentActive : state => {
        return state.user_content_active;
    },
    getPageLoading : state => {
        return state.page_loading;
    },
    getPermissions : state => {
        return state.permissions;
    },
    getName : state => {
        return state.name;
    },
    getUser : state => {
        return state.user;
    },
    getListaId : state => {
        return state.lista_id;
    },
    getTeatroId : state => {
        return state.teatro_id;
    },
    getPermisos : state => {
        return state.permisos;
    },
    getGd : state => {
        return state.gd;
    },
    getListas : state => {
        return state.listas;
    },
    getListaActiva : state => {
        return state.lista_activa;
    },
    getDatafono : state => {
        return state.datafono;
    },
    getPuedeUsarDatafono : state => {
        return state.puede_datafono;
    }
}

const mutations = {
    setEventCanView: (state, event_id) => {
        state.event_can_view = event_id;
    },
    setEventsCanView: (state, events) => {
        state.events_can_view = events;
    },
    setUserToken : (state, token) => {
        state.token = token;
        localStorage.setItem('token', token);
    },

    setIsLogged : (state, is_logged) => {
        state.is_logged = is_logged;
    },

    setRole : (state, role) => {
        state.role = role;
    },
    setMenuActive : state => {
        state.search_active = false;
        state.user_content_active = false;
        state.menu_active = !state.menu_active;
    },
    setSearchActive : state => {
        state.menu_active = false;
        state.user_content_active = false;
        state.search_active = !state.search_active;
    },
    setUserContentActive : state => {
        state.menu_active = false;
        state.search_active = false;
        state.user_content_active = !state.user_content_active;
    },
    setPageLoading : (state, loading) => {
        state.page_loading = loading;
    },
    setPermissions : (state, permissions) => {
        state.permissions = permissions;
    },
    setName : (state, name) => {
        state.name = name;
    },
    setUser : (state, user) => {
        state.user = user;
    },
    setListaId : (state, lista_id) => {
        state.lista_id = lista_id;
        localStorage.setItem('lista_id', lista_id);
    },
    setTeatroId : (state, teatro_id) => {
        state.teatro_id = teatro_id;
        localStorage.setItem('teatro_id', teatro_id);
    },
    setPermisos : (state, permisos) => {
        state.permisos = permisos;
    },
    setGd : (state, gd) => {
        state.gd = gd;
    },
    setListas : (state, listas) => {
        state.listas = listas;
    },
    setListaActiva : (state, lista_activa) => {
        state.lista_activa = lista_activa;
    },
    setDataUser : (state, user) => {
        if (user.tipo != 'user') {
            state.user = user;
            state.lista_id = user.lista.id;
            // Persistir para que AppLoader.setLista() restaure tras reload
            // (sin esto, page reload pierde la lista activa y la navegación
            // a /admin/abonados (sin ID) redirige a home).
            localStorage.setItem('lista_id', user.lista.id);
            state.teatro_id = user.teatro.id;
            localStorage.setItem('teatro_id', user.teatro.id);
            state.permisos = user.permisos;
            state.gd = user.gd;
            state.listas = user.listas;
            state.lista_activa = user.lista;
        } else {
            state.user = user;
        }
    },
    setDatafono: (state, datafono) => {
        state.datafono = datafono;
    },
    setPuedeUsarDatafono: (state, puede_datafono) => {
        state.puede_datafono = puede_datafono;
    }
}

const actions = {
    LOGIN : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('login'), data).then(res => {
                if(res.data.auth){
                    commit('setUserToken', res.data.api_key);
                    commit('setIsLogged', res.data.auth);
                    commit('setDataUser', res.data.user);
                    if (res.data.user.tipo == 'compania') {
                        commit('setEventCanView', res.data.user.event_id);
                        commit('setEventsCanView', res.data.user?.events ?? null);
                    }			
                }else{
                    reject(res);
                }

                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    CHECK : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('check'), data).then(res => {
                if(res.data.user){
                    if(res.data.auth){
                        commit('setUserToken', res.data.api_key);
                        commit('setIsLogged', res.data.auth);
                        commit('setDataUser', res.data.user);
                        if (res.data.user.tipo == 'compania') {
                            commit('setEventCanView', res.data.user.event_id);
                            commit('setEventsCanView', res.data.user?.events ?? []);
                        }
                    }else{
                        reject(res);
                    }
                }else{
                    reject(res);
                }

                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    logout : function({ commit }, data){
        const { resetPerfil } = usePerfil();
        resetPerfil();
        data.router.push({ name : 'login' });
        commit('setUserToken', null);
        commit('setIsLogged', false);
        commit('setPermissions', []);
        commit('setUser', null);
        commit('setFrontEvents', null);
        commit('setFrontExperiencias', null);
    },

    FORGOT_PASSWORD : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('forgot-password'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    RESET_PASSWORD : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('reset-password'), data).then(res => {
                if(res.data.auth){
                    commit('setUserToken', res.data.api_key);
                    commit('setIsLogged', res.data.auth);
                    commit('setUser', res.data.user);
                }else{
                    reject(res);
                }

                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    REGISTER: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('register'), data).then(res => {
                if (res.data.auth) {
                    commit('setUserToken', res.data.api_key);
                    commit('setIsLogged', res.data.auth);
                    commit('setDataUser', res.data.user);
                } else {
                    reject(res);
                }

                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    setActiveDatafono: function({ commit }, datafono) {
        commit('setDatafono', datafono);
    },
    
    setPuedeUsarDatafono: function({ commit }, puede_datafono) {
        commit('setPuedeUsarDatafono', puede_datafono);
    }
}

export default {
    state,
    actions,
    getters,
    mutations
};
